const errorCode = {
	existingResource: '409',
};

export { errorCode };
